<h1 mat-dialog-title>{{data.titleText}}</h1>
<mat-dialog-actions class="dialog-navigation" align="end">
    <button mat-button color="primary" mat-dialog-close>Cancel</button>
    <button mat-button color="primary" mat-dialog-close="true">Proceed</button>
</mat-dialog-actions>